import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Pencil, Plus } from "lucide-react";
import { AddTraining } from "./TrainingEditors";

// Approved informational content around a system page (e.g. the Directory). The system page itself stays locked.
export function PageInfoContent({ pageKey, collection, category }) {
  const [page, setPage] = useState(null);
  const [items, setItems] = useState([]);
  const [manage, setManage] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = useCallback(() => {
    api.get(`/training-center/${pageKey}`).then((r) => {
      setPage(r.data);
      if (r.data.can_content) api.get("/content/manage", { params: { type: "article" } }).then((m) => setManage(m.data.items.filter((x) => x.collection === collection && (x.organization_ids || []).includes(r.data.group_id)))).catch(() => setManage([]));
      api.get("/content/library", { params: { type: "article", collection } }).then((l) => setItems(l.data.items)).catch(() => setItems([]));
    }).catch(() => setPage(null));
  }, [pageKey, collection]);
  useEffect(() => { load(); }, [load]);
  if (!page) return null;
  const pub = new Set(items.map((i) => i.id));
  const extra = manage.filter((m) => !pub.has(m.id));
  if (!items.length && !page.can_content) return null;
  return (
    <section className="mt-4 rounded-xl border border-slate-200 bg-white p-4" data-testid={`info-${pageKey}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-semibold text-slate-900">Information &amp; resources{page.groups.length > 1 && page.can_content ? ` · Editing for: ${page.groups.find((g) => g.id === page.group_id)?.name || ""}` : ""}</p>
        {page.can_content && <Button size="sm" variant="outline" onClick={() => setEdit({})} data-testid={`info-${pageKey}-add`}><Plus className="w-4 h-4 mr-1" />Add Article</Button>}
      </div>
      {!items.length && !extra.length && <p className="text-sm text-slate-500 mt-2">Add instructions, helpful links or Group announcements for this page.</p>}
      <div className="mt-2 divide-y divide-slate-100">
        {[...items, ...extra].map((i) => (
          <div key={i.id} className="py-2" data-testid={`info-item-${i.id}`}>
            <div className="flex items-start gap-2">
              <div className="flex-1 min-w-0"><Link to={`/training/${i.id}`} className="font-medium text-slate-900 hover:underline">{i.title}</Link>
                {i.status && i.status !== "published" && <span className="ml-2 text-xs rounded bg-amber-100 text-amber-800 px-1.5 py-0.5">{i.status}</span>}
                {i.summary && <p className="text-sm text-slate-600">{i.summary}</p>}</div>
              {page.can_content && <Button size="sm" variant="ghost" onClick={() => setEdit(manage.find((m) => m.id === i.id) || i)} data-testid={`info-edit-${i.id}`}><Pencil className="w-4 h-4 mr-1" />Edit</Button>}
            </div>
            {i.body_html && i.status === undefined && <div className="tr-page text-sm mt-1 line-clamp-3" dangerouslySetInnerHTML={{ __html: i.body_html }} />}
          </div>))}
      </div>
      {edit && <AddTraining page={page} item={edit.id ? edit : null} kind="article" collection={collection} fixedCategory={category} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} />}
    </section>);
}
